import { RequestStatus } from '@sales-center/common'
import { Activity } from '@user/features/Activity'
import { get } from '@user/store/services/crud'
import { useEffect, useState } from 'react'
import { toast } from '@sales-center/components'
import { getActivityUrl } from '../constants'

export const useGetActivityOnMount = (activityId: number | undefined) => {
  const [activity, setActivity] = useState<Activity>()
  const [status, setStatus] = useState<RequestStatus>()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (activityId) {
        try {
          if (mounted) {
            setStatus('loading')
            const response = await get(`${getActivityUrl}/${activityId}`)

            if (response.ok) {
              setActivity(await response.json())
              setStatus('success')
            } else {
              setStatus('error')
              toast.error('Error loading activity.')
            }
          }
        } catch {
          if (mounted) {
            setStatus('error')
          }
        }
      } else {
        setActivity(undefined)
        setStatus('success')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [activityId, setStatus, setActivity])

  return { activity, status }
}
